// This dictionary contains 14 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { surveyLocalization } from "survey-core";

export var norwegianSurveyStrings = {
  pagePrevText: "Forrige",
  pageNextText: "Neste",
  completeText: "Fullfør",
  previewText: "Forhåndsvisning",
  editText: "Redigere",
  startSurveyText: "Start",
  otherItemText: "Annet (beskriv)",
  noneItemText: "Ingen",
  selectAllItemText: "Velg alle",
  progressText: "Side {0} av {1}",
  // indexText: "{0} of {1}",
  panelDynamicProgressText: "Ta opp {0} av {1}",
  questionsProgressText: "Besvarte {0} / {1} spørsmål",
  emptySurvey: "Det er ingen synlig side eller spørsmål i undersøkelsen.",
  completingSurvey: "Takk for at du fullførte undersøkelsen!",
  completingSurveyBefore: "Våre data viser at du allerede har gjennomført denne undersøkelsen.",
  loadingSurvey: "Undersøkelsen laster...",
  placeholder: "Velg...",
  // ratingOptionsCaption: "Select...",
  value: "verdi",
  requiredError: "Vennligst svar på spørsmålet.",
  requiredErrorInPanel: "Vennligst svar på minst ett spørsmål.",
  requiredInAllRowsError: "Vennligst svar på spørsmål i alle rader.",
  numericError: "Verdien skal være numerisk.",
  // minError: "The value should not be less than {0}",
  // maxError: "The value should not be greater than {0}",
  textMinLength: "Vennligst skriv inn minst {0} tegn.",
  textMaxLength: "Vennligst skriv inn mindre enn {0} tegn.",
  textMinMaxLength: "Vennligst skriv inn mer enn {0} og mindre enn {1} tegn.",
  minRowCountError: "Vennligst fyll inn minst {0} rader.",
  minSelectError: "Vennligst velg minst {0} varianter.",
  maxSelectError: "Vennligst ikke velg mer enn {0} varianter.",
  numericMinMax: "'{0}' bør være lik eller mer enn {1} og lik eller mindre enn {2}",
  numericMin: "'{0}' bør være lik eller mer enn {1}",
  numericMax: "'{0}' bør være lik eller mindre enn {1}",
  invalidEmail: "Vennligst skriv inn en gyldig e-post adresse.",
  invalidExpression: "Uttrykket: {0} skal returnere 'sant'.",
  urlRequestError: "Forespørselen returnerte feilen '{0}'. {1}",
  urlGetChoicesError: "Forespørselen returnerte tomme data, eller 'sti' -egenskapen er feil",
  exceedMaxSize: "Filstørrelsen bør ikke overstige {0}.",
  otherRequiredError: "Vennligst skriv inn den andre verdien.",
  uploadingFile: "Filen din lastes opp. Vennligst vent noen sekunder og prøv igjen.",
  loadingFile: "Laster inn ...",
  chooseFile: "Velg fil (er) ...",
  noFileChosen: "Ingen fil valgt",
  // fileDragAreaPlaceholder: "Drop a file here or click the button below to load the file.",
  confirmDelete: "Ønsker du å slette posten?",
  keyDuplicationError: "Denne verdien skal være unik.",
  addColumn: "Legg til kolonne",
  addRow: "Legg til rad",
  removeRow: "Fjern",
  // emptyRowsText: "There are no rows.",
  addPanel: "Legg til ny",
  removePanel: "Fjerne",
  choices_Item: "element",
  matrix_column: "Kolonne",
  matrix_row: "Rad",
  // multipletext_itemname: "text",
  savingData: "Resultatene lagres på serveren ...",
  savingDataError: "Det oppsto en feil, og vi kunne ikke lagre resultatene.",
  savingDataSuccess: "Resultatene ble lagret!",
  saveAgainButton: "Prøv igjen",
  timerMin: "min",
  timerSec: "sek",
  timerSpentAll: "Du har tilbrakt {0} på denne siden og {1} totalt.",
  timerSpentPage: "Du har tilbrakt {0} på denne siden.",
  timerSpentSurvey: "Du har tilbrakt {0} totalt.",
  timerLimitAll: "Du har tilbrakt {0} av {1} på denne siden og totalt {2} av {3}.",
  timerLimitPage: "Du har tilbrakt {0} av {1} på denne siden.",
  timerLimitSurvey: "Du har tilbrakt {0} av {1} totalt.",
  clearCaption: "Klar",
  // signaturePlaceHolder: "Sign here",
  chooseFileCaption: "Velg Fil",
  removeFileCaption: "Fjern denne filen",
  booleanCheckedLabel: "Ja",
  booleanUncheckedLabel: "Nei",
  confirmRemoveFile: "Er du sikker på at du vil fjerne denne filen: {0}?",
  confirmRemoveAllFiles: "Er du sikker på at du vil fjerne alle filene?",
  questionTitlePatternText: "Spørsmålstittel",
  // modalCancelButtonText: "Cancel",
  // modalApplyButtonText: "Apply",
  // filterStringPlaceholder: "Type to search...",
  // emptyMessage: "No data to display",
  // noEntriesText: "There are no entries yet.\nClick the button below to add a new entry.",
  // more: "More"
};

surveyLocalization.locales["no"] = norwegianSurveyStrings;
surveyLocalization.localeNames["no"] = "norsk";
